import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './Label.scss';
import { FormInputContext } from '../index';

class Label extends React.Component {
  static propTypes = {
    /** custom classname to add to the component. */
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { className, context, children } = this.props;

    return (
      <div
        className={classnames('common-label', className, {
          'common-label--optional': !context.required,
        })}
      >
        {children}
      </div>
    );
  }
}

export default props => (
  <FormInputContext.Consumer>
    {context => <Label {...props} context={context} />}
  </FormInputContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/components/common/label/Label.js